import * as yup from 'yup';
import i18n from '../i18n';

export const RegisterSchema = yup.object().shape({
  companyName: yup.string().required(i18n.t('requiredField')),
  userName: yup
    .string()
    .required(i18n.t('requiredField'))
    .email(i18n.t('invalidEmailValidation')),
  firstName: yup.string().required(i18n.t('requiredField')),
  jobPostion: yup.string().required(i18n.t('requiredField')),
  lastName: yup.string().required(i18n.t('requiredField')),
  // sectorId: yup.number().typeError(i18n.t('mustBeNumberValidation')).required(i18n.t('requiredField')),
  phoneNumber: yup.string().required(i18n.t('requiredField')),
  countryId: yup.number().typeError(i18n.t('mustBeNumberValidation')).required(i18n.t('requiredField')),
  city: yup.string().required(i18n.t('requiredField')),
  password: yup
    .string()
    .required(i18n.t('requiredField'))
    .min(6, i18n.t('passwordLengthValidation')),
  confirmPassword:  yup
    .string()
    .required(i18n.t('requiredField'))
    .min(6, i18n.t('confirmPasswordLengthValidation'))
    .oneOf([yup.ref('password'), null], i18n.t('passwordsMustMatch')),
    visitor: yup.boolean(),
    numbeEmployees: yup.number().typeError(i18n.t('mustBeNumberValidation')).when('visitor', {
      is: true,
      then: yup.number().required(i18n.t('requiredField'))
    }),
    // jobPostion validation not working as expected
    // jobPostion: yup.string().required(i18n.t('requiredField')).when('visitor', {
    //   is: true,
    //   then: yup.string().required(i18n.t('requiredField'))
    // }),
  GDPRText: yup.boolean().oneOf([true],i18n.t('mustApproveGDPR')),
});

export const LoginSchema = yup.object().shape({
  email: yup
    .string()
    .required(i18n.t('requiredField'))
    .email(i18n.t('invalidEmailValidation')),
  password: yup
    .string()
    .required(i18n.t('requiredField')),
});

export const requestSchema = yup.object().shape({
  requestName: yup
      .string()
      .required(i18n.t('requiredField')),
  requestEmail: yup
      .string()
      .required(i18n.t('requiredField'))
      .email(i18n.t('invalidEmailValidation')),
  requestPhone: yup
      .string()
      .required(i18n.t('requiredField')),
  requestSubject: yup
      .string()
      .required(i18n.t('requiredField')),
  requestMessage: yup
      .string()
});
